import jQuery from 'jquery';
import Radio from 'backbone.radio';
import CodeLayout from '@/views/code_layout';
import ide_settings from '@/models/ide_settings';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');
var routerCh = Radio.channel('router');

// Must fetch individual deployments and drafts to get agent/device code,
// because it's not included in the full collection response.
function maybe_fetch_code_model(code_model) {
    // Don't try to fetch the model if it hasn't been saved yet
    if (code_model.rel.get('devicegroup')) {
        return jQuery.Deferred().resolve().then( function(){  code_model.fetch(); });
    }
    return code_model.fetch();
}

function show_view(code_model, devicegroup, device) {
    const active_account = globalCh.request('active_account');
    var product = devicegroup.rel.get('product');
    var app_layout = globalCh.request('app_layout');
    var code_layout = new CodeLayout({
        model: code_model,
        devicegroup: devicegroup,
        device: device,
        settings: ide_settings
    });


    app_layout.showChildView('container', code_layout);
    if ( devicegroup.type === 'production_devicegroup' || devicegroup.type === 'factoryfixture_devicegroup' || devicegroup.type === 'pre_production_devicegroup' ){
        globalCh.request('show_devicegroup_secondary_nav', devicegroup, { selected: 'code-editor', code_model: code_model });
    } else {
        globalCh.request('show_dev_devicegroup_secondary_nav', devicegroup, { selected: 'code-editor', code_model: code_model});
    }

    var set_selection_options = {
            v5_object: devicegroup,
            id: devicegroup.id,
            type: devicegroup.type
    };

    // HANDLE DRAFT / DEPLOYMENT LOGIC
    if (code_model.type === 'draft') {
        code_layout.enable_draft_state(code_model);
    } else if (code_model.type === 'deployment') {
        code_layout.enable_readonly_deployment_state(code_model);
        if (devicegroup.draft) {
            code_layout.enable_return_to_draft(devicegroup.draft);
        }
    }
    if (devicegroup && devicegroup.rel && devicegroup.rel.get('owner')) {
        if (devicegroup.rel.get('owner') !== active_account) {
            globalCh.request('changeActiveAccount', devicegroup.rel.get('owner'), function () {
                globalCh.request('set_selection', set_selection_options);
                
                if (code_model.type === 'deployment'){
                    routerCh.request('set_location', 'devicegroup_deployment', product, devicegroup, code_model, device);
                } else {
                    routerCh.request('set_location', 'devicegroup_draft', product, devicegroup);
                }
            });        
        } else {
            globalCh.request('set_selection', set_selection_options);

            if (code_model.type === 'deployment') {
                routerCh.request('set_location', 'devicegroup_deployment', product, devicegroup, code_model, device);
            } else {
                routerCh.request('set_location', 'devicegroup_draft', product, devicegroup);
            }
        }
    }
}

function show_code_editor(code_model, devicegroup, device) {
    var agent_code = code_model.get('agent_code');
    var device_code = code_model.get('device_code');
    var deployment_id = code_model.get('deployment_id');

    var devicegroups = apiCh.request('development_devicegroup');
    var deployments = apiCh.request('deployment');
    var product = devicegroup.rel.get('product');


    function fetch_devicegroups() {
        if (product) {
            return devicegroups.fetch({ data: {
                'filter[product.id]': product.id,
                'include': 'current_deployment'
            }});
        } else {
            return devicegroups.fetch({ data: {
                'include': 'current_deployment'
            }});
        }
    }

    function set_code_model_to_latest_deployment(r) {
        var latest_deployment = devicegroup.rel.get('current_deployment');
        if ( !latest_deployment ) return false;
        return code_model.save({
            device_code: latest_deployment.get('device_code'),
            agent_code: latest_deployment.get('agent_code'),
            deployment_id: latest_deployment.get('id'),
        });
    }
    function fetch_latest_deployment(r) {
        if ( !devicegroup.rel.get('current_deployment') ) return false;
        return devicegroup.rel.get('current_deployment').fetch();
    }

    var should_fetch_latest_deployment = (agent_code === null && device_code === null && deployment_id === null) || (agent_code === "" && device_code === "");
    ide_settings.fetch();
    if ( code_model.type === 'draft' ) {
        devicegroup.fetch_draft()
        .then(()=>{
            if (should_fetch_latest_deployment) {
                deployments.fetch({ data: {
                    'filter[devicegroup.id]': devicegroup.id
                }})
                .then(fetch_latest_deployment)
                .then(set_code_model_to_latest_deployment)
                .then(show_view.bind(this, code_model, devicegroup, device));
            } else {
                fetch_devicegroups()
                .then(show_view.bind(null, code_model, devicegroup, device));
            }
        })
        .catch(()=>{
            // Draft does not exist: 404
            if (should_fetch_latest_deployment) {
                devicegroup.fetch({
                    data: {
                        'include': 'current_deployment'
                    }
                })
                    .then(fetch_latest_deployment)
                    .then(set_code_model_to_latest_deployment)
                    .then(show_view.bind(this, code_model, devicegroup, device));
            } else {
                // Otherwise, just set draft to be blank and save it
                devicegroup.draft.save()
                    .then(fetch_devicegroups)
                    .then(show_view.bind(null, code_model, devicegroup, device));
            }
        });
    } else {
        maybe_fetch_code_model(code_model)
        .then(fetch_devicegroups)
        .then(show_view.bind(null, code_model, devicegroup, device));
    }
}

export default show_code_editor;
